import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgressBar = () => {
    const { scrollYProgress } = useScroll();
    const progress = useSpring(scrollYProgress, {
        stiffness: 120,
        damping: 30,
        mass: 0.3,
    });

    return (
        <motion.div
            style={{ scaleX: progress }}
            className="fixed top-0 left-0 right-0 h-[3px] origin-left bg-gradient-to-r from-electric via-cyan-300 to-emerald-400 z-[60] pointer-events-none"
            data-testid="scroll-progress"
            aria-hidden
        />
    );
};
